/**
 * Created by guga on 7/29/2016.
 */

import { Injectable } from '@angular/core';
import { Response }   from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

import { IRequestErrorHandler, IXhrErrorHandler } from '../sas-models/error-handler';
import { IXhrResponse }                           from '../sas-models/xhr-types';

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 29/07/2016
 *
 * This service is responsible for handle all types of errors in sas library
 * All sas services have this service as a dependency
 * You can change the the error handlers to create a custom error handler
 * All error handlers need to return an Observable
 *
 * Examples of use :
 *
 *   ## CHANGE REQUEST ERROR HANDLER
 *   this._errorHandler.setRequestErrorHandler(
 *     (error : Response, requestPayload : IRequestPayload) => {
 *        return Observable.throw('My custom handler');
 *     }
 *   );
 *
 *   ## CHANGE AUTHENTICATION ERROR HANDLER
 *   this._errorHandler.setAuthenticationErrorHandler(
 *     (error : Response, requestPayload : IRequestPayload) => {
 *        return Observable.throw('My custom handler');
 *     }
 *   );
 *
 *   ## CALLING DEFAULT HANDLER FROM CUSTOM HANDLER
 *   this._errorHandler.setRequestErrorHandler(
 *     (error : Response, requestPayload : IRequestPayload) => {
 *        console.log('This is a log message');
 *        return this._errorHandler.defaultRequestErrorHandler(error);
 *     }
 *   );
 *
 ***********************************************/

@Injectable()
export class ErrorHandlerSas {
    private _requestErrorHandler            : IRequestErrorHandler;
    private _authenticationErrorHandler     : IRequestErrorHandler;
    private _xhrErrorHandler                : IXhrErrorHandler;

    public constructor() {
        this._requestErrorHandler         = this.defaultRequestErrorHandler;
        this._authenticationErrorHandler  = this.defaultAuthenticationErrorHandler;
        this._xhrErrorHandler             = this.defaultXhrErrorHandler;
    }

    public defaultRequestErrorHandler(error : Response) : Observable<any> {
        let errorMessage : string = `[${error.status}] : ${error.statusText}`;
        return Observable.throw(errorMessage);
    }
    public defaultAuthenticationErrorHandler(error : Response) : Observable<any> {
        let errorMessage : string = `[${error.status}] : ${error.statusText}`;
        return Observable.throw(errorMessage);
    }
    public defaultXhrErrorHandler(error : IXhrResponse) : Observable<any> {
        let errorMessage : string = `[${error.status}] : ${error.statusText}`;
        return Observable.throw(errorMessage);
    }

    get requestErrorHandler() : IRequestErrorHandler {
        return this._requestErrorHandler;
    }
    get authenticationErrorHandler() : IRequestErrorHandler {
        return this._authenticationErrorHandler;
    }
    get xhrErrorHandler() : IXhrErrorHandler {
        return this._xhrErrorHandler;
    }

    public setRequestErrorHandler(errorHandler : IRequestErrorHandler) : void {
        this._requestErrorHandler = errorHandler;
    }
    public setAuthenticationErrorHandler(errorHandler : IRequestErrorHandler) : void {
        this._authenticationErrorHandler = errorHandler;
    }
    public setXhrErrorHandler(errorHandler : IXhrErrorHandler) : void {
        this._xhrErrorHandler = errorHandler;
    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/error-handler.sas.ts